module.exports = __webpack_public_path__ + "static/img/TG.d92760f4.svg";